export default "__VITE_ASSET__BA_e8CCs__"